import { ApplicationController, useThrottle } from 'stimulus-use'
import { log } from "../../javascript/utils/logger"

export default class extends ApplicationController {
  static throttles = ['onMapChange']

  connect() {
    useThrottle(this, { wait: 1000 })

    log("advocate card list connect")
  }

  disconnect() {
    log("advocate card list disconnect")
  }

  onMapChange(event) {
    log("update from map change!", event)
    if (event.detail && event.detail.center) {
      const { lat, lng } = event.detail.center
      this.element.src = `/advocates?lat=${lat}&lng=${lng}`
    }
  }
}
